import React from "react";
import Modal from "react-responsive-modal";
import { FaTimes, FaPlus, FaTrash, FaCalendarAlt } from "react-icons/fa";
import DatePicker from "react-datepicker";
import axios from "axios";
import moment from 'moment';
import { apiUri } from "../../../config";
import "./DisclosureDates.css";

const no_duplicates_error = ' is already existed';

class DisclosureDatesComponent extends React.Component {

    newDisclosureObj = {
        caseId: this.props.caseId,
        disclosureDate: null,
        disclosureId: null
    }

    constructor(props) {
        super(props);
        this.state = {
            disclosureDates: this.props.disclosureDates.length ? this.props.disclosureDates : [this.newDisclosureObj],
            disclosureDateError: ''
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.disclosureDates) {
            this.setState({
                disclosureDates: [...nextProps.disclosureDates]
            })
        }
    }

    handleCloseCalendarModal = () => {
        this.props.handleOpenCalendarModal(false);
    };

    // Making an API call to save the add/update disclosure date(s)
    handleOnBlur = (event, index) => {
        const { disclosureDates } = this.state;
        // Validating date
        if (!moment(event.target.value).isValid() || this.state.disclosureDateError) {
            if (disclosureDates[index].disclosureId) {
                this.props.getDisclosureDates(this.props.caseId);
            } else {
                disclosureDates[index] = this.newDisclosureObj;
                this.setState({
                    disclosureDates: [...disclosureDates]
                });
            }
            return null;
        }
        const { disclosureDate, disclosureId } = disclosureDates[index];
        const date = new Date(disclosureDate);
        if (disclosureDate && moment(date).isValid()) {
            let disclosures = [];
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            const formattedDate = `${date.getFullYear()}-${month}-${day}`;
            disclosures.push({ ...disclosureDates[index], disclosureDate: formattedDate });

            axios.put(`${apiUri}/cases/${this.props.caseId}/disclosure`, { disclosures })
            .then(res => {
                if (res && res.data && res.data.statusCode === 200) {
                    if(!disclosureId && Array.isArray(res.data.content) && res.data.content.length > 0){
                        disclosureDates[index].disclosureId = res.data.content[0].disclosureId;
                    }
                    this.setState({ disclosureDates });
                }
            })
            .catch(err => {
                console.log(err);
            });
        }
    }

    // Handling add/edit disclosure date
    handleOnChange = (event, index) => {
        if (event) {
            const newDate = new Date(event);
            // Handling duplicate disclosure date
            if (this.state.disclosureDates.some(dateObj => dateObj.disclosureDate === newDate.getTime())) {
                this.setState({
                    disclosureDateError: moment(newDate).format('YYYY-MM-DD') + no_duplicates_error
                });
            } else {
                const updatedDates = [...this.state.disclosureDates];
                if (updatedDates[index] && updatedDates[index].disclosureId) {
                    updatedDates[index].disclosureDate = newDate.getTime();
                } else {
                    updatedDates[index] = {
                        caseId: this.props.caseId,
                        disclosureId: null,
                        disclosureDate: newDate.getTime(),
                    };
                }
                this.setState({
                    disclosureDates: [...updatedDates],
                    disclosureDateError: ''
                });
            }
        }
    };

    // Adding new disclosure date field
    handleDisclosureDateAdd = (index) => {
        let updatedDisclosureDates = [...this.state.disclosureDates];
        updatedDisclosureDates[index + 1] = this.newDisclosureObj;
        this.setState({
            disclosureDates: [...updatedDisclosureDates]
        });
    };

    // Making API call to delete a disclosure date
    deleteDisclosureDate = (index, disclosureId) => {
        const { disclosureDates } = this.state;
        disclosureDates.splice(index, 1);
        this.setState({
            disclosureDates: [...disclosureDates]
        },() => {
            if (disclosureId !== null) {
                axios
                .delete(`${apiUri}/cases/${this.props.caseId}/disclosure/${disclosureId}`)
                .then(res => {
                    if (res && res.data && (res.data.statusCode === 204 || res.data.statusCode === 200)) {
                        if(disclosureDates.length === 0){
                            disclosureDates.push(this.newDisclosureObj);
                            this.setState({
                                disclosureDates: [...disclosureDates]
                            });
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            }
        })
    };

    render() {
        return (
            <React.Fragment>
                <Modal
                    open={this.props.openCalendarModal}
                    onClose={this.handleCloseCalendarModal}
                    focusTrapped={false}
                >
                    <div className="ModalWindow modaladd">
                        <FaTimes className="closeicon" onClick={this.handleCloseCalendarModal} />
                        <h3 className="modalHeading">Disclosure Dates</h3>
                        <div className="NavDivider"></div>
                        <div id={"disclosure-dates-holder"}>
                            <div className="m-t-20">
                                {this.state.disclosureDates.map((dateObj, index) => (
                                    <div className="datepicker-container" style={{ paddingTop: 16 }} key={index}>
                                        <DatePicker
                                            showIcon
                                            className="date_picker pt-0"
                                            selected={dateObj.disclosureDate}
                                            onChange={(evt) => this.handleOnChange(evt, index)}
                                            onBlur={(evt) => this.handleOnBlur(evt, index)}
                                            dateFormat="yyyy-MM-dd"
                                            placeholderText="YYYY-MM-DD"
                                        />
                                        <FaCalendarAlt className="calendar-icon" />
                                        <span>
                                            {((this.state.disclosureDates.length > 1) ||
                                                (this.state.disclosureDates.length === 1 && dateObj.disclosureDate) ) &&
                                                <FaTrash className="dateOption trash_icon" onClick={() => this.deleteDisclosureDate(index, dateObj.disclosureId)} />
                                            }
                                            {(index === this.state.disclosureDates.length - 1) &&
                                                <FaPlus className="dateOption plus_icon" onClick={() => this.handleDisclosureDateAdd(index)} />
                                            }
                                        </span>
                                    </div>
                                ))}
                                {this.state.disclosureDateError && <span id="error-style">
                                    {this.state.disclosureDateError}
                                </span>}
                            </div>
                            <div className="textCenter mt-3 mb-3">
                                <button className="btn btnC" onClick={this.handleCloseCalendarModal}>Close</button>
                            </div>
                        </div>
                    </div>
                    <div className="NavDivider"></div>
                </Modal>
            </React.Fragment>
        )
    }
}

export default DisclosureDatesComponent;


// WEBPACK FOOTER //
// ./src/common/components/DisclosureDates/DisclosureDatesComponent.js